module.exports = __webpack_public_path__ + "media/images/column_banner-a28a502532c3ebcd325b58c2d2f24fe0.jpg";